import React from 'react';
import styled from 'styled-components';

import { textTypes, brandColors, breakpoint } from '../../constants/styles';

const texts = [];

const textGenerator = (element) => {
  if (!styled[element]) element = 'div';
  return styled[element]`
    ${(props) => (textTypes[props.type] ? textTypes[props.type] : '')}
    color: ${(props) => (brandColors[props.color] ? brandColors[props.color] : '')};
    text-align: ${(props) => props.align};
    ${breakpoint('small', 'medium')`
      ${({ smallType }) => (textTypes[smallType] ? textTypes[smallType] : '')}  
      ${({ smallColor }) => (smallColor ? `color: ${smallColor}` : '')}  
    `}
    ${breakpoint('medium', 'large')`
      ${({ mediumType }) => (textTypes[mediumType] ? textTypes[mediumType] : '')}  
      ${({ mediumColor }) => (mediumColor ? `color: ${mediumColor}` : '')}  
    `}
    ${breakpoint('large')`
      ${({ largeType }) => (textTypes[largeType] ? textTypes[largeType] : '')}  
      ${({ largeColor }) => (largeColor ? `color: ${largeColor}` : '')}  
    `}
  `;
};

const Text = ({
  element = 'div',
  type,
  color,
  smallType,
  mediumType,
  largeType,
  smallColor,
  mediumColor,
  largeColor,
  align = 'left',
  children,
  ...props
}) => {
  if (!texts[element]) texts[element] = textGenerator(element);
  const TextBase = texts[element];
  return (
    <TextBase
      smallType={smallType}
      mediumType={mediumType}
      largeType={largeType}
      smallColor={smallColor}
      mediumColor={mediumColor}
      largeColor={largeColor}
      type={type}
      color={color}
      align={align}
      {...props}
    >
      {children}
    </TextBase>
  );
};

export default Text;
